import React, { Component, Fragment } from 'react'
import { Button, TableRow, TableCell, IconButton, Tooltip } from '@material-ui/core'

// utils
import { onChangeEditHOF } from '../../utils/common'
import { hasAccess } from '../../utils/api'

import { EditableTextField, EditableSwitch } from '../common/EditableComponents'
import EditActionComponent from '../common/EditActionComponent'
import { FormatListBulleted, Info } from '@material-ui/icons'

export default class MetrcEmployeeKey extends Component {
  onChange = onChangeEditHOF(this.props.onChange)

  onSave = () => {
    this.props.onSave((response) => this.props.disableEdit())
  }

  onCancel = () => {
    this.props.onCancel()
  }

  render() {
    const { data = {}, editMode, onSelectEmployee } = this.props

    const permitted = hasAccess()
    const viewPermissionDisabled = !data.userApiKey

    return (
      <TableRow>
        <TableCell className="cell-wrap-word">
          <EditableTextField
            valueToRender={data.employeeName}
            editMode={false}
            value={data.employeeName}
            type="text"
            InputLabelProps={{
              shrink: true,
            }}
          />
        </TableCell>
        <TableCell className="cell-wrap-word">
          <EditableTextField
            valueToRender={data.userApiKey}
            editMode={editMode}
            value={data.userApiKey}
            onChange={this.onChange('userApiKey')}
            type="text"
            InputLabelProps={{
              shrink: true,
            }}
          />
        </TableCell>
        <TableCell style={{ position: 'relative' }}>
          <IconButton disabled={viewPermissionDisabled} aria-label="View API permission">
            <FormatListBulleted onClick={() => onSelectEmployee(data)} />
          </IconButton>

          {viewPermissionDisabled && (
            <Tooltip title="Select API Key and Facility License to view API permission">
              <Info
                color="action"
                style={{ fontSize: 16, position: 'absolute', left: 52, bottom: 28 }}
              />
            </Tooltip>
          )}
        </TableCell>
        <TableCell className="cell-wrap-word">
          <EditableSwitch
            valueToRender={data.enabled ? 'Enabled' : 'Disabled'}
            checked={data.enabled}
            editMode={editMode}
            onChange={this.onChange('enabled', true)}
          />
        </TableCell>
        <TableCell className="cell-wrap-word">
          {permitted ? (
            <Fragment>
              <EditActionComponent
                onSave={this.onSave}
                onCancel={this.onCancel}
                onEdit={this.props.enableEdit}
                editMode={editMode}
              />
              {!editMode ? (
                <Button className="danger-button margin" onClick={this.props.onDelete}>
                  Delete
                </Button>
              ) : null}
            </Fragment>
          ) : (
            <Fragment></Fragment>
          )}
        </TableCell>
      </TableRow>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Metrc/MetrcEmployeeKey.js